<template>
    <div class="row justify-content-center my-4" v-if="showBtn">
        <div class="col-12 col-sm-6">
            <a class="btn btn-dark w-100" href="#app">
                <span>Back to Top</span>
            </a>
        </div>
    </div>

</template>

<script>
export default {
    name: "NavigateTop",
    props: {
        items: Number,
        showBtn:{
            Boolean,
            default: false
        }
    },
    mounted() {
        if(/Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
            this.showBtn = true
        }
        else if(this.items >= 19){
            this.showBtn = true
        }

    }
}
</script>

<style scoped>

</style>
